import React from 'react'

import classNames from './ErrorMessage.css'

export default function ErrorMessage ({ onRetry, message = 'There was an error' }) {
  return (
    <div>
      <p className={classNames.message}>
        {message}
      </p>
      {onRetry &&
        <button
          className={classNames.button}
          onClick={onRetry}>
          Retry
        </button>
      }
    </div>
  )
}



// WEBPACK FOOTER //
// ./src/components/ErrorMessage.js